import parseDicomHeaderLine from "./dicom-header-line";
import regexes from "./regexes";
export default (output) => {
  const response = {};
  // remove any null bytes
  output = output.replace(regexes.nullByte, ""); // eslint-disable-line no-param-reassign
  // split on newlines
  const lines = output.trim().split(/\r?\n/);
  /**
   * Parse response lines
   */
  response.results = [];
  let currentItem;
  let startSave = true;
  lines.forEach((line) => {
    // match result beginning line
    if (regexes.matchResponseNumber.test(line)) {
      // start new item
      const [, responseNumber] = regexes.matchResponseNumber.exec(line); // Find Reponse
      currentItem = { responseNumber, dataset: [] };
      response.results.push(currentItem);
      return true;
    }
    if (!currentItem) return true;
    if (regexes.matchTransferSyntax.test(line)) {
      [, currentItem.transferSyntax] = regexes.matchTransferSyntax.exec(line); // Little Endian Explicit
      return true;
    }
    const header = parseDicomHeaderLine(line);
    if (header && header.tag) {
      if (header.tag.toLocaleLowerCase() === "fffe,e000") startSave = false;
      if (header.vr !== "SQ" && startSave) {
        currentItem[header.tag] = header;
      }
      if (header.tag.toLocaleLowerCase() === "fffe,e00d") startSave = true;
      currentItem.dataset = currentItem.dataset || [];
      currentItem.dataset.push(header);
    }
  });
  return response;
};



// WEBPACK FOOTER //
// ./src/mainInterface/js/dicom/worklist-proc.js